import amplitude from 'amplitude-js';
import * as amplitudeEvents from './amplitude-events.constants';

const KEAP_AMPLITUDE_V2_KEY = window.keapAmplitudeKey;
const KEAP_AMPLITUDE_V2_INSTANCE_NAME = window.keapAmplitudeName;
const INFU_AMPLITUDE_V1_KEY = window.infuAmplitudeKey;
const INFU_AMPLITUDE_V1_INSTANCE_NAME = window.infuAmplitudeName;

const events = {
    KEAP_AMPLITUDE_V2_KEY,
    KEAP_AMPLITUDE_V2_INSTANCE_NAME,
    INFU_AMPLITUDE_V1_KEY,
    INFU_AMPLITUDE_V1_INSTANCE_NAME,
    ...amplitudeEvents,
};

export default {
    keap: {
        events,

        init() {
            if (KEAP_AMPLITUDE_V2_INSTANCE_NAME && KEAP_AMPLITUDE_V2_KEY) {
                amplitude.getInstance(KEAP_AMPLITUDE_V2_INSTANCE_NAME).init(KEAP_AMPLITUDE_V2_KEY);
            }
        },

        setup({
            appName,
            companyName,
            editionName,
            isPaid,
            isPartner,
            isReferredByPartner,
            domain,
        }) {
            if (!KEAP_AMPLITUDE_V2_INSTANCE_NAME || !KEAP_AMPLITUDE_V2_KEY) return;

            const amplitudeInstance = amplitude.getInstance(
                KEAP_AMPLITUDE_V2_INSTANCE_NAME,
            );

            amplitudeInstance.setUserId(appName);

            // If editionName is not set, it probably means none of these values are reliable (like on a public page)
            if (editionName) {
                amplitudeInstance.setUserProperties({
                    Domain: domain,
                    'Company Name': companyName,
                    'Edition Key': editionName,
                    'Is Paid': isPaid,
                    'Is Partner': isPartner,
                    'Is Referred by Partner': isReferredByPartner,
                });
            }
        },

        setUserId(userId) {
            amplitude.getInstance(
                KEAP_AMPLITUDE_V2_INSTANCE_NAME,
            ).setUserId(userId);
        },

        setUserProperties(props) {
            amplitude.getInstance(
                KEAP_AMPLITUDE_V2_INSTANCE_NAME,
            ).setUserProperties(props);
        },

        logEvent(name, data = null) {
            if (!Object.values(events).includes(name)) {
                // eslint-disable-next-line no-console
                console.warn(
                    `"${name}" is not a valid Amplitude Event. Please ensure that all events being sent to Amplitude are approved by your leader, listed in the amplitude-events.constants.js file, and added to the production Amplitude schema.`,
                );

                return;
            }

            amplitude.getInstance(KEAP_AMPLITUDE_V2_INSTANCE_NAME).logEvent(name, data);
        },

        incrementUserProp(propName, count) {
            const identify = new amplitude.Identify();

            identify.add(propName, count);

            amplitude.getInstance(KEAP_AMPLITUDE_V2_INSTANCE_NAME).identify(identify);
        },

        setOnce(propName, value) {
            const identify = new amplitude.Identify();

            identify.setOnce(propName, value);

            amplitude.getInstance(KEAP_AMPLITUDE_V2_INSTANCE_NAME).identify(identify);
        },
    },

    infusionsoft: {
        events,

        init() {
            if (INFU_AMPLITUDE_V1_KEY) {
                amplitude.getInstance(INFU_AMPLITUDE_V1_INSTANCE_NAME).init(INFU_AMPLITUDE_V1_KEY);
            }
        },

        track(name, data = null) {
            if (INFU_AMPLITUDE_V1_KEY) {
                amplitude.getInstance(INFU_AMPLITUDE_V1_INSTANCE_NAME).logEvent(name, data);
            }
        },

        setUserId(userId) {
            if (INFU_AMPLITUDE_V1_KEY) {
                amplitude.getInstance(INFU_AMPLITUDE_V1_INSTANCE_NAME).setUserId(userId);
            }
        },

        setUserProperties(props) {
            if (INFU_AMPLITUDE_V1_KEY) {
                amplitude.getInstance(INFU_AMPLITUDE_V1_INSTANCE_NAME).setUserProperties(props);
            }
        },
    },
};
